module.exports = __webpack_public_path__ + "cancel.png?2e55c0d895839003a51db5fdb486ef4c";